import { ooId } from 'data/mock-data';

const mock = () => ({
  data: { orderID: ooId },
});

export default mock;
